import * as React from 'react'
import { Pane } from 'evergreen-ui'

export default function CommonTopPageHeader({ children }){
  return (
    <Pane display="flex" flexDirection="row" justifyContent="space-between" paddingY={15} alignItems="center">
      {children}
    </Pane>
  )
}